import { Alert, Modal, Steps } from 'antd'
import { useCallback, useState } from 'react'
import logo from 'src/assets/logo.png'
import MigrateCopyTimeline from 'src/components/migrate/MigrateCopyTimeline'
import MigrateResultPage from 'src/components/migrate/MigrateResult'
import MigrationSelectTimeline from 'src/components/migrate/MigrateSelectTemplate'
import MigrateValidateItems from 'src/components/migrate/MigrateValidateItems'
import { CloneTimelineRes } from 'src/service/OrgSyncService'
import { twMerge } from 'tailwind-merge'

const steps = [
  {
    title: 'Select Project & Template',
    description: 'Choose the project and template to copy.',
  },
  {
    title: 'Validate Items',
    description: 'Ensure all disciplines and Users exist in the new project.',
  },
  {
    title: 'Monitor Copy Process',
    description: 'Follow the copying process as it happens.',
  },
  {
    title: 'Copy Summary',
    description: 'Review the results and details of the copying process.',
  },
]

const initState = { 0: false, 1: false, 2: false, 3: false }
type CanMoveStep = {
  [key: number]: boolean
}

const MigratePage = () => {
  const [current, setCurrent] = useState(0)
  const [confirmModal, setConfirmModal] = useState(false)
  const [canMoveStep, setStepCanMove] = useState<CanMoveStep>(initState)
  const [migrateRes, setMigrateRes] = useState<CloneTimelineRes>()

  const next = () => {
    if (current < 1) {
      setCurrent(current + 1)
    } else if (current == 1) {
      setConfirmModal(true)
    }
  }

  const prev = () => {
    setCurrent(current - 1)
  }

  const setCanMove = useCallback((step: number, canMove: boolean) => {
    setStepCanMove((prev) => ({ ...prev, [step]: canMove }))
  }, [])

  const elements = [
    <MigrationSelectTimeline
      key={'select_template'}
      canMove={(v) => setCanMove(0, v)}
    />,
    <MigrateValidateItems
      key={'validate_items'}
      canMove={(v) => setCanMove(1, v)}
    />,
    <MigrateCopyTimeline
      key={'copy_timeline'}
      migrationRes={(d) => {
        setMigrateRes(d)
        setCurrent(3)
      }}
    />,
    <MigrateResultPage key={'migration_result'} res={migrateRes} />,
  ]

  return (
    <div className="flex flex-col h-full w-full gap-4">
      <div className="mb-2 flex flex-col gap-2">
        <img className="h-10 w-32" src={logo} alt="taskCtrl-logo" />
        <h1 className="text-xl font-bold">Copy Project Template</h1>
        <hr />
      </div>
      <div className="flex h-[90%] w-full gap-4">
        <div>
          <Steps direction="vertical" current={current} items={steps} />
        </div>
        <div
          className={twMerge(
            'w-full flex justify-center h-full',
            current === 1 ? 'items-start' : 'items-center',
          )}
        >
          {elements[current]}
        </div>
        <div className="absolute z-50 bottom-0 left-0 right-0 flex gap-4">
          {current > 0 && (
            <button
              disabled={current > 1}
              className={'button !mr-0'}
              style={{ margin: '0 8px' }}
              onClick={() => prev()}
            >
              Previous
            </button>
          )}
          {current < steps.length - 1 && (
            <button
              disabled={!canMoveStep[current]}
              className={'button button-primary !mr-0'}
              onClick={() => next()}
            >
              Next
            </button>
          )}
          {current === steps.length - 1 && (
            <button
              className={'button button-primary !mr-0'}
              onClick={() => miro.board.ui.closeModal()}
            >
              Done
            </button>
          )}
        </div>
        <Modal
          title="Migrate Timeline"
          open={confirmModal}
          onOk={() => {
            setConfirmModal(false)
            setCurrent(2)
          }}
          onCancel={() => setConfirmModal(false)}
          mask={false}
          okText="Migrate"
          okButtonProps={{
            className: '!bg-[#1677ff] hover:scale-105',
          }}
        >
          <Alert
            message="Do you want to migrate the selected timeline?"
            description="This action cannot be undone."
            type="warning"
          />
        </Modal>
      </div>
    </div>
  )
}

export default MigratePage
